// api should be here
import { http } from '@/utils/http';
import qs from 'qs';
import { isWeiXin } from '@/common/ts/common';
// 活动api baseurl
const urlPrefix = 'vote/2021project/q1/2021ninedream/controller.php?enews=';

const getBaseInfo = () => {
  return http.get(`${urlPrefix}base-info`);
};

const getVoteList = (
  type: number,
  page: number,
  order: any,
  keyword?: string,
) => {
  return http.get(`${urlPrefix}prize-list`, {
    params: {
      workType: type,
      page,
      search: keyword,
      order,
    },
  });
};

const getDetail = (id: number | string) => {
  return http.get(`${urlPrefix}prize-detail`, {
    params: {
      id,
    },
  });
};

const nextLastId = (id: any) => {
  return http.get(`${urlPrefix}prizeNextLastId`, {
    params: {
      number: id,
    },
  });
};

// 获取数据统计量
const getTotalData = () => {
  return http.get(`${urlPrefix}Statistics`);
};
const addPageView = () => {
  return http.get(`${urlPrefix}addRead`);
};
const share = (context: any) => {
  context.$appShareInfo({
    title: '九童圆梦牛年春节行动',
    url: location.href,
    subtitle: '寻根乡愁 记住年味',
    classId: -1,
    id: -1,
    image: 'http://image2.cqcb.com/1075dd015b5d3b3545e6379f33081b4e.jpeg',
    type: 3,
  });
  // 微信分享
  if (isWeiXin()) {
    context.$wxShareInfo({
      title: '九童圆梦牛年春节行动',
      subtitle: '寻根乡愁 记住年味',
      image: 'http://image2.cqcb.com/1075dd015b5d3b3545e6379f33081b4e.jpeg',
    });
  }
};

export {
  getBaseInfo,
  getVoteList,
  getDetail,
  share,
  nextLastId,
  getTotalData,
  addPageView,
};
